import React from 'react'

import Typography from 'components/atoms/Typography'
import MoreInfo from 'components/atoms/SVGIcons/MoreInfo'

const SummaryBox = ({ title, value, notes, unit }) => (
  <div className="paperplane-summary-box">
    <div className="paperplane-summary-box__wrapper">
      <Typography component="h5" variant="subheading" className="paperplane-summary-box__title">
        {title}
      </Typography>
      <div>
        <Typography component="h2" className="paperplane-summary-box__value">
          {value}
        </Typography>
        {
          unit &&
          <Typography component="h3" variant="caption" className="paperplane-summary-box__unit">
            {unit}
          </Typography>
        }
      </div>
    </div>
    {
      notes &&
      <div className="paperplane-summary-box__more-info">
        <MoreInfo fill="#d3dce6" />
        <Typography component="span" variant="note">
          {notes}
        </Typography>
      </div>
    }
    <style jsx>
      {`
        .paperplane-summary-box {
          flex-basis: 50%;
          width: 342px;
          &:not(:first-child) {
            margin-left: 16px;
          }
          :global(&__title) {
            padding-bottom: 16px;
            font-weight: bold !important;
          }
          &__wrapper {
            height: 76px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 16px;
            box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
            border-radius: 10px;
            color: #7d92a9;
            text-align: center;
          }
          :global(&__value) {
            font-size: 42px !important;
            font-weight: bold !important;
            color: #1a344f;
            line-height: 1 !important;
          }
          :global(&__unit) {
            color: #6b8fbc !important;
          }
          &__more-info {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            background-color: #f6f7fa;
            display: flex;
            padding: 8px 12px;
            :global(span) {
              color: #7d92a9;
            }
            :global(svg) {
              margin-right: 8px;
              flex: none;
            }
          }

          @media screen and (max-width: 767px) {
            width: auto;
            &:not(:first-child) {
              margin: 16px 0 0 0;
            }
            :global(&__title) {
              font-size: 14px !important;
              padding: 0;
            }
            :global(&__value) {
              font-size: 28px !important;
            }
            &__more-info {
              :global(svg) {
                flex-basis: 7%;
              }
            }
          }
        }
      `}
    </style>
  </div>
)

export default SummaryBox
